
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/campaign/[campaign]",
      function () {
        return require("private-next-pages/dining/campaign/[campaign].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/campaign/[campaign]"])
      });
    }
  